export const LINK_SELECTED = 'Link Selected';

export const BUTTON_SELECTED = 'Button Selected';

export const CLOSE_BUTTON_SELECTED = 'Close Button Selected';

export const EXPANDED = 'Expanded';

export const COLLAPSED = 'Collapsed';
